export const algoHasError = ({ hasError = false }) => hasError;

export const algoHasWaiting = (s = {}) => {
  const { configurations = {}, hasWaitingWT = false, hasWaiting = false } = s;
  const { isWaitAndTradeEnabled = false } = configurations;
  const hasWaitingMod = isWaitAndTradeEnabled ? hasWaitingWT : hasWaiting;

  return hasWaitingMod;
};

export const algoHasStoplossTrailing = ({ stoplossTrailing = false }) =>
  stoplossTrailing;

export const algoHasBrokerDisabled = (s = {}, brokersDataAll = []) => {
  if (!s.broker) {
    return false;
  }

  const { brokerDisabled = false } =
    brokersDataAll.find((op) => op && op.value && op.value === s.broker) || {};

  return brokerDisabled;
};
